import dayjs from 'dayjs';

import defaultImageMerchant from 'src/global/assets/icons/merchant-default-icon.svg';
import unknownBank from 'src/global/assets/images/unknown-bank.png';
import unknownIssuer from 'src/global/assets/icons/credit-card.svg';
import {
  ECardType,
  ETransactionPaymentStatuses,
  dictionaryCardType,
  dictionaryTransactionStatus
} from 'src/interfaces/transactions';

export const getStatusTransactionLabel = (payment_status: ETransactionPaymentStatuses | undefined) => {
  if (!payment_status || !(payment_status in ETransactionPaymentStatuses)) {
    return '';
  }
  return dictionaryTransactionStatus[payment_status as keyof typeof ETransactionPaymentStatuses];
};

export const getNameCardType = (card_type: ECardType | undefined | null) => {
  if (!card_type || !(card_type in ECardType)) {
    return '';
  }
  return dictionaryCardType[card_type as keyof typeof ECardType];
};

export const getImageBank = (bankImage: string | undefined | null) => {
  return bankImage || unknownBank;
};

export const getImageIssuer = (issuerImage: string | undefined | null) => {
  return issuerImage || unknownIssuer;
};

export const getImageMerchant = (marchantImage: string | undefined | null) => {
  return marchantImage || defaultImageMerchant;
};


/**
 * H6: sin filtros aplicados, el portal (KPIs y listado) refleja los ultimos 30 dias.
 * Vive aca para que la barra de metricas y la tabla consulten SIEMPRE el mismo universo.
 */
export const DEFAULT_RANGE_DAYS = 30;

export const withDefaultRange = <T extends { from?: string | null; to?: string | null }>(
  filter: T,
  hasAnyValue: boolean
): T => {
  if (hasAnyValue) return filter;
  return {
    ...filter,
    from: dayjs().subtract(DEFAULT_RANGE_DAYS, 'day').toISOString(),
    to: dayjs().toISOString()
  };
};
